var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":"https://assets.crossref.org/logo/crossref-logo-100.png","alt":"Crossref logo","aspect-ratio":"1.538","max-height":"50px","max-width":"72px","min-height":"36px","min-width":"72px"}})}
var staticRenderFns = []

export { render, staticRenderFns }